import classNames from 'classnames';

import { useZoomCall } from 'hooks';
import { useWidth } from 'hooks/useWidth';

import { ParticipantsProps } from './participants.types';
import Participant from './Participant';
import { getParticipantItemClassNames } from './participants.settings';

const Participants: React.FC<ParticipantsProps> = ({ activeSpeakers, participants }) => {
  const { isMobile } = useWidth();
  const { isMinimize, isOpenChat } = useZoomCall();

  const isMinimizeOrMobile = isMinimize || (isMobile && isOpenChat);

  return (
    <div className="absolute bottom-37.5 left-4 z-10 flex items-stretch overflow-hidden rounded-2xl bg-white shadow-xl md:bottom-4">
      {participants.map((participant) => {
        const isSpeaking = activeSpeakers?.some((speaker) => speaker.userId === participant.userId);
        return (
          <div
            key={participant.userId}
            className={classNames(
              'relative flex items-center justify-center',
              getParticipantItemClassNames({
                bVideoOn: participant.bVideoOn,
                isMinimizeOrMobile,
                isMobile,
                participantsCount: participants.length
              })
            )}
          >
            <Participant {...participant} isSpeaking={isSpeaking} />
          </div>
        );
      })}
    </div>
  );
};

export default Participants;
